import React from "react";
import { MultiSelect } from "primereact/multiselect";
import { useTranslation } from "react-i18next";
// Import images
import workSpace from "assets/images/icons/workspace.svg";
import workShop from "assets/images/icons/workshop.svg";
import meetingRoom from "assets/images/icons/meetingRoom.svg";
import hotDesk from "assets/images/icons/hotDesk.png";
import office from "assets/images/icons/office.png";

const MultipleSelect = ({
  value,
  handleMultipleSelectChange,
  options,
  placeholder = "Select Options",
  maxSelectedLabels,
  className = "",
  disabled = false,
}) => {
  const { t } = useTranslation();

  // Map value to image
  const iconMap = {
    workSpace,
    meetingRoom,
    workShop,
    hotDesk,
    office,
  };

  const itemTemplate = (option) => (
    <div className="flex align-items-center gap-2">
      {iconMap[option.value] && (
        <img
          src={iconMap[option.value]}
          alt={option.name}
          width={18}
          height={18}
          style={{ objectFit: "contain" }}
          className="mx-2"
        />
      )}
      <span className="text_dark_gray">{option.name}</span>
    </div>
  );

  return (
    <MultiSelect
      value={value}
      onChange={(e) => handleMultipleSelectChange(e.value)}
      options={options}
      optionLabel="name"
      display="chip"
      itemTemplate={itemTemplate}
      placeholder={placeholder}
      selectAllLabel={t("Select All")}
      // maxSelectedLabels={maxSelectedLabels ? maxSelectedLabels : false}
      className={`w-100 custom_multi_select ${className}`}
      disabled={disabled}
      filter
      filterPlaceholder={t("Search")}
    />
  );
};

export default MultipleSelect;
